@if (status$ | async; as status) {
  <div class="status">
    @if (!skeletonView) {
      <app-date [date]="order.statusChangeAt"
        [placeholder]="'ORDERS.COMMON.STATUS.status_never_changed' | translate"
        [tooltip]="'ORDERS.COMMON.STATUS.status_changed_at' | translate"
        icon="update">
      </app-date>
      @if (!status.isRemoved) {
        <app-chip class="status-name" backgroundColor="primary">
          {{ status.name }}
        </app-chip>
      } @else {
        <app-chip class="status-name" backgroundColor="muted" [matTooltip]="'ORDERS.COMMON.STATUS.deleted' | translate">
          {{ status.name }}
        </app-chip>
      }
    } @else {
      <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px', borderRadius: '50px' }"></ngx-skeleton-loader>
    }
  </div>
}
